// jQuery
(function ($) {
  $(function () {

    $('.js--lazy:not(.js--lazy-init)').addClass('js--lazy-init').Lazy();

  });
})(jQuery);
